let API_ENDPOINT_URL = 'https://api.roomready.northwestern.edu';
var API_ENDPOINT_ENV_PATH = '';
const ENV = process.env.NODE_ENV;

switch (ENV) {
  case 'local':
    API_ENDPOINT_URL = 'https://local.api.roomready.mtiapp.northwestern.edu:3000';
    API_ENDPOINT_ENV_PATH = '/local';
    break;

  case 'development':
    API_ENDPOINT_ENV_PATH = '/dev';
    break;

  case 'main': // fallthrough
  case 'prod': // fallthrough
  case 'production':
    API_ENDPOINT_ENV_PATH = '/prod';
    break;

  default:
    console.error(`E_NODE_ENV_IS_INVALID: ${ENV}`);
    break;
}

export const API_ENDPOINT_BASE_URL = API_ENDPOINT_URL + API_ENDPOINT_ENV_PATH;
export const API_VERSION = '2';
export const API_ENDPOINT_REPORT = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/report';
export const API_ENDPOINT_STATUS_REPORTS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/status-report';
export const API_ENDPOINT_ROOMS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/rooms';
export const API_ENDPOINT_GENERATE_REPORT = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/generate-report';
export const API_ENDPOINT_TEAMS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/teams';
export const API_ENDPOINT_SMARTSHEETS = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/sheets';
export const API_ENDPOINT_AUTH = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/authenticate';
export const API_ENDPOINT_LOGOUT = API_ENDPOINT_BASE_URL + '/api/v' + API_VERSION + '/logout';
export const API_ENDPOINT_PING = API_ENDPOINT_BASE_URL + '/ping';



// WEBPACK FOOTER //
// ./src/constants/roundsApiEndpoints.js